import Vue from 'vue'
import Buefy from 'buefy'
import App from './App.vue'
import router from './router'
/*import 'buefy/dist/buefy.css'*/

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(Buefy, { defaultIconPack: 'fas' })

new Vue({
  router,
  render: h => h(App),
  watch: {
    $route (to, from){
        document.querySelectorAll('.navbar-burger')[0].classList.remove('is-active')
        document.getElementById('navbarBasicExample').classList.remove('is-active')
    }
  }
}).$mount('#app')
